const domainQrScannerEn = {
  aria: {
    cameraError: 'Camera error occurred',
    cameraStarting: 'Camera starting',
    scanPaused: 'Scan paused',
    scanReady: 'Scan ready',
    scannerLabel: 'QR code scanner'
  },
  error: {
    constraintNotSatisfied: 'Camera configuration requirements not met',
    dangerousQr: 'Potentially dangerous QR code detected',
    deviceBusy: 'Camera device is busy',
    insecureContext: 'HTTPS is required. Please access via secure connection',
    invalidQrData: 'Invalid QR code data',
    message: 'Cannot access camera.\nPlease check your browser settings.',
    notAllowed: 'Camera access denied',
    notFound: 'Camera not found',
    notReadable: 'Camera is being used by another application',
    privateBrowsing: 'Camera is not available in private browsing mode',
    timeout: 'Camera startup timed out',
    title: 'Camera Error',
    unknown: 'An unknown error occurred',
    unsupportedBrowser: 'Your browser does not support camera access'
  },
  guide: {
    message: 'Align QR code within the frame'
  },
  loading: {
    message: 'Starting camera...'
  },
  paused: {
    message: 'Scan paused'
  },
  retry: {
    buttonText: 'Retry'
  }
};
export default domainQrScannerEn;